require('./componentSettings.i18n.json');
require('./componentSettings.tpl.html');
require('./componentSettingsConstant.js');
require('./componentSettingsController.js');
require('./componentSettingsMediator.js');
require('./componentSettingsUtil.js');
require('./repository/fieldTemplateComponentRepository.js');
require('./optionGroup/optionGroupComponent.js');
require('./optionGroup/optionGroupComponent.js');

const ComponentSettingsComponent = {
    templateUrl: '/configuration/formEditor/content/form/componentSettings/componentSettings.tpl.html',
    controller: 'componentSettingsController',
    bindings: {
        selectedField: '<',
        selectedFieldStructure: '<',
        fieldStructure: '<',
        scrollableContainerSelector: '<'
    }
};

angular.module('ums.configuration')
    .component('uiComponentSettings', ComponentSettingsComponent);
